import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import i18n from "./vendors/i18n/i18n";
import Vuelidate from "./vendors/vue-validate";

Vue.config.productionTip = false;
Vue.use(Vuelidate);

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
});
